<script setup lang="ts">
  interface Props {
    value?: string;
  }

  const props = defineProps<Props>();

  const emits = defineEmits<{
    (e: 'colorSelected', color: string): void;
  }>();

  const colors = [
    '#000000',
    '#e60000',
    '#ff9900',
    '#ffff00',
    '#008a00',
    '#0066cc',
    '#9933ff',
    '#ffffff',
    '#facccc',
    '#ffebcc',
    '#ffffcc',
    '#cce8cc',
    '#cce0f5',
    '#ebd6ff',
    '#bbbbbb',
    '#f06666',
    '#ffc266',
    '#ffff66',
    '#66b966',
    '#66a3e0',
    '#c285ff',
    '#888888',
    '#a10000',
    '#b26b00',
    '#b2b200',
    '#006100',
    '#0047b2',
    '#6b24b2',
    '#444444',
    '#5c0000',
    '#663d00',
    '#666600',
    '#003700',
    '#002966',
    '#3d1466',
  ];
</script>

<template>
  <div class="grid grid-cols-7 w-fit gap-1">
    <div
      v-for="color in colors"
      :key="color"
      class="h-4 w-4 border rounded border-border cursor-pointer hover:opacity-70 transition-opacity"
      :class="{ 'border-foreground': props.value === color }"
      :style="{ backgroundColor: color }"
      @click="emits('colorSelected', color)"
    ></div>
  </div>
</template>

<style scoped></style>
